const RadioButtonGroupComponent = {
    templateUrl: '/formViewer/component/radioButtonGroup/radioButtonGroup.tpl.html',
    controller: 'radioButtonGroupController',
    bindings: {
        fieldStructure: '<',
        timeLastModified: '<',
        hideLabel: '<'
    }
};

angular.module('umFormViewer')
    .component('radioButtonGroup', RadioButtonGroupComponent);
